var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcArrowUp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "7px",
    viewBox: "0 0 13 7",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icArrowUp") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.452003,3.19971697 C9.46497089,3.41099245 9.39500374,3.62636782 9.24210155,3.79340218 L4.2616103,9.23422124 C4.00981761,9.50928617 3.58271511,9.52815205 3.30765017,9.27635935 C3.29299084,9.2629403 3.27893111,9.24888057 3.26551206,9.23422124 C2.98361576,8.92627034 2.98361576,8.45400832 3.26551206,8.14605743 L7.79336073,3.19971697 L3.26551206,-1.74662349 C2.98361576,-2.05457439 2.98361576,-2.52683641 3.26551206,-2.83478731 C3.51730475,-3.10985224 3.94440725,-3.12871812 4.21947219,-2.87692542 C4.23413152,-2.86350636 4.24819125,-2.84944664 4.2616103,-2.83478731 L9.24210155,2.60603175 C9.39500374,2.77306611 9.46497089,2.98844148 9.452003,3.19971697 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icArrowUp",
    fill: "#333333",
    fillRule: "nonzero",
    transform: "translate(6.253807, 3.199717) rotate(-90.000000) translate(-6.253807, -3.199717) ",
    xlinkHref: "#path-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowUp);
export default __webpack_public_path__ + "static/media/icArrowUp.71590a05fb7c1b44586c6a95dcf403f7.svg";
export { ForwardRef as ReactComponent };